<template>
  <v-select
    :items="monthOptions"
    v-bind="$attrs"
    :value="value"
    :label="trans('general.month')"
    @input="$emit('input', $event)"
  ></v-select>
</template>

<script>
import {DateUtils} from '../utils/date-utils';
import {LocaleUtils} from '@/utils/locale-utils';

export default {
  name: 'SelectMonth',
  mixins: [
    DateUtils,
    LocaleUtils
  ],
  props: {
    value: {
      default () {
        return null;
      }
    }
  },
  computed: {
    monthOptions () {
      let months = [];

      for (let month = 1; month <= 12; month++) {
        months.push({
          text: this.getMonthNameByIndex(month),
          value: month
        });
      }

      return months;
    }
  }
}
</script>
